import React from 'react';
import { FaFileAlt, FaDownload, FaUserMd, FaClipboardCheck, FaDatabase } from 'react-icons/fa';

const services = [
  {
    title: 'Access to Hospital Policies & SOPs',
    description: 'Browse and reference standardized hospital management policies and procedures.',
    icon: <FaFileAlt className="text-blue-600 text-3xl" />,
  },
  {
    title: 'Downloadable Hospital Management Systems',
    description: 'Access ready-to-deploy hospital management software for your facility.',
    icon: <FaDownload className="text-green-600 text-3xl" />,
  },
  {
    title: 'Consultation for Healthcare Governance',
    description: 'Expert advisory services for clinical governance and operational strategy.',
    icon: <FaUserMd className="text-purple-600 text-3xl" />,
  },
  {
    title: 'Compliance Tools (National Standards)',
    description: 'Automated tools and checklists to ensure regulatory compliance.',
    icon: <FaClipboardCheck className="text-red-600 text-3xl" />,
  },
  {
    title: 'Healthcare Research Data Repository',
    description: 'Centralized access to datasets for planning, analysis, and innovation.',
    icon: <FaDatabase className="text-teal-600 text-3xl" />,
  },
];

const ServicesOfferedComponent = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
      {services.map((service, index) => (
        <div
          key={index}
          className="bg-white shadow-md rounded-lg p-5 flex flex-col items-start space-y-3 hover:shadow-lg transition"
        >
          {service.icon}
          <h3 className="text-lg font-semibold">{service.title}</h3>
          <p className="text-gray-600">{service.description}</p>
        </div>
      ))}
    </div>
  );
};

export default ServicesOfferedComponent;
